import { ContainerDocument, ContainerViewer } from './styles';

interface IRViewerProps {
  children?: React.ReactNode | string;
}

export const RViewer: React.FC<IRViewerProps> = ({ children }) => {
  return (
    <ContainerViewer>
      <ContainerDocument>{children}</ContainerDocument>
    </ContainerViewer>
  );
};
